/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ToggleButton from 'react-bootstrap/ToggleButton';
import SortIcon from "../../assests/img/sort-icon.svg";
import "react-datepicker/dist/react-datepicker.css";
import { MultiSelect } from "react-multi-select-component";
import UpArrowDropdown from '../../assests/img/UpArrow_dropdown.svg'
import DownArrowDropdown from '../../assests/img/DownArrow_dropdown.svg'
import { useLocation } from "react-router-dom";

const Filter = ({
  filterOptions,
  selectedFilters,
  handleCheckboxChange,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  statusOptions,
  selectedStatus,
  handleStatusChange,
  ticketTypeOptions,
  selectedTicketTypes,
  setSelectedTicketTypes,
  departmentOptions,
  selectedDepartments,
  setSelectedDepartments,
  companyOptions,
  selectedCompanies,
  setSelectedCompanies,
  categoryOptions,
  selectedCategories,
  setSelectedCategories,
  filteredSubCategoryOptions,
  selectedSubCategories,
  setSelectedSubCategories,
  handleClearAll,
  handleSubmit,
  isApplyFilterDisabled,
  handleClearAllTcikets,
  filterCount,
  showClearAll,
  selectedTicketStatus,
  setSelectedTicketStatus,
  ticketStatusOptions,
  ratingsOptions,
  selectedRatings,
  setSelectedRatings,

  selectedLocation,

  setApplyFilterValue,

  applyFilterValue,

  supportTicketChecked,
  setSupportTicketChecked,
  filterDatakeLie,
  
  quickClearFilterDisable,

  quick,
  checkedStates,
  handleToggleChange,
  activeTab
}) => {
  const [inputType, setInputType] = useState('text');
  const [inputTypeTo, setInputTypeTo] = useState('text');

const location =useLocation();
const queryParams = new URLSearchParams(location.search);
const globalTicket = queryParams.get("ticketNumber");


  const ArrowRenderer = ({ expanded }) => <>{expanded ? <img src={DownArrowDropdown} className="ddArrow" /> : <img src={UpArrowDropdown} className="ddArrow" />}</>;


  const ValueRendererCompany = (selectedCompany, optionsComapny) => {
    if (selectedCompany.length === optionsComapny.length) {
      return 'All companies';
    } else if (selectedCompany.length === 1) {
      return selectedCompany[0].label;
    } else {
      return selectedCompany.length > 0
        ? `${selectedCompany.length} companies selected`
        : 'Select';
    }
  };

  const ValueRendererDepartment = (selectedDept, optionsDept) => {
    if (selectedDept.length === optionsDept.length) {
      return 'All departments';
    } else if (selectedDept.length === 1) {
      return selectedDept[0].label;
    } else {
      return selectedDept.length > 0
        ? `${selectedDept.length} departments selected`
        : 'Select';
    }
  };

 
  const ValueRendererCategory = (selectedCat, optionsCat) => {
    if (selectedCat.length === optionsCat.length) {
      return 'All categories';
    } else if (selectedCat.length === 1) {
      return selectedCat[0].label;
    } else {
      return selectedCat.length > 0
        ? `${selectedCat.length} categories selected`
        : 'Select';
    }
  };

  const ValueRendererSubCategory = (selectedSub, optionsSub) => {
    if (optionsSub.length === 0) {
      return "Select";
    }
    if (selectedSub.length === optionsSub.length) {
      return 'All sub-categories';
    } else if (selectedSub.length === 1) {
      return selectedSub[0].label;
    } else {
      return selectedSub.length > 0
        ? `${selectedSub.length} sub-categories selected`
        : 'Select';
    }
  };
  




  const ValueRendererTicket = (selectedTkt, optionsTkt) => {
    if (selectedTkt.length === optionsTkt.length) {
      return 'All ticket types';
    } else if (selectedTkt.length === 1) {
      return selectedTkt[0].label;
    } else {
      return selectedTkt.length > 0
        ? `${selectedTkt.length} ticket types selected`
        : 'Select';
    }
  };


 
  const ValueRendererTicketStatus = (
    selectedTicketStatus,
    optionsTicketStatus
  ) => {
    if (selectedTicketStatus.length === optionsTicketStatus.length) {
      return "All ticket status";
    } else if (selectedTicketStatus.length === 1) {
      return selectedTicketStatus[0].label;
    } else {
      return selectedTicketStatus.length > 0
        ? `${selectedTicketStatus.length} ticket status selected`
        : "Select";
    }
  };

  const ValueRendererRatings = (selectedRatings, optionsRatings) => {
    if (selectedRatings.length === optionsRatings.length) {
      return "All ratings";
    } else if (selectedRatings.length === 1) {
      return selectedRatings[0].label;
    } else {
      return selectedRatings.length > 0
        ? `${selectedRatings.length} ratings selected`
        : "Select";
    }
  };

  return (
    <Fragment>
       {activeTab !== "opened" && activeTab !== "close"?
      <div className="ticketListSortBar">

        {!globalTicket && quick.length > 0 ?
        <div className="ToggleByStatus">
          {/* <button className="Filt_Status_btn active">Support tickets</button>
          <button className="Filt_Status_btn">Snag tickets</button> */}
          {quick.map((filterItem) => (
            <ToggleButton
              key={filterItem.label}
              id={`toggle-${filterItem.label}`}
              className="Filt_Status_Toggle"
              type="checkbox"
              variant="dark"
              checked={checkedStates[filterItem.label]}
              onChange={(e) => handleToggleChange(filterItem.label, e.currentTarget.checked)}
            >
              {filterItem.label}
            </ToggleButton>
            
          ))}
        </div> : ""}

        
        <span className="ClearFilterList" style={{ cursor: "pointer" }} onClick={() => handleClearAllTcikets()}>
        {showClearAll && applyFilterValue && quickClearFilterDisable ? "Clear Filter" : ""}
        </span>


        <div className="SortFilterSection">
          <Dropdown>
            <Dropdown.Toggle variant="" className="SortFilterDD">
            <img src={SortIcon} alt="Sort Icon" /><span>{filterCount !== 0 ? `Filter(${filterCount})` : "Filter"}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="FilterDD_Content">
              {/* <Dropdown.ItemText className="FilterOptions">
                <div className="FilterOptions_Checks">
                  {filterOptions.map((option) => (
                    <div key={option.value}>
                      <input
                        type="checkbox"
                        className="btn-check"
                        id={`${option.value}-check`}
                        autoComplete="off"
                        checked={selectedFilters.includes(option.value)}
                        onChange={() => handleCheckboxChange(option.value)}
                      />
                      <label
                        className="btn FilterOptions_Checks_Btn"
                        htmlFor={`${option.value}-check`}
                      >
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </Dropdown.ItemText> */}
              <Dropdown.ItemText className="FilterForm">
                <div>
                  <div className="FilterForm_Row">
                    <label className="form-label">Company Name</label>
                    <MultiSelect
                      options={companyOptions}
                      value={selectedCompanies}
                      onChange={setSelectedCompanies}
                      labelledBy="Select Companies"
                      ArrowRenderer={ArrowRenderer}
                      className="FilterMultiselect"
                      valueRenderer={ValueRendererCompany}
                    />
                  </div>
                  <div className="FilterForm_Row">
                    <label className="form-label">Department</label>
                    <MultiSelect
                      options={departmentOptions}
                      value={selectedDepartments}
                      onChange={setSelectedDepartments}
                      labelledBy="Select Departments"
                      ArrowRenderer={ArrowRenderer}
                      className="FilterMultiselect"
                      valueRenderer={ValueRendererDepartment}
                    />
                  </div>
                  <div className="FilterForm_Row">
                    <label className="form-label">Category</label>
                    <MultiSelect
                      options={categoryOptions}
                      value={selectedCategories}
                      onChange={setSelectedCategories}
                      labelledBy="Select Categories"
                      ArrowRenderer={ArrowRenderer}
                      className="FilterMultiselect"
                      valueRenderer={ValueRendererCategory}
                    />
                  </div>
                  <div className="FilterForm_Row">
                    <label className="form-label">Sub-Category</label>
                    <MultiSelect
                      options={filteredSubCategoryOptions}
                      value={selectedSubCategories}
                      onChange={setSelectedSubCategories}
                      labelledBy="Select Sub-Categories"
                      ArrowRenderer={ArrowRenderer}
                      className="FilterMultiselect"
                      valueRenderer={ValueRendererSubCategory}
                    />
                  </div>
                  <div className="FilterForm_Row">
                    <label className="form-label">Ticket Type</label>
                    <MultiSelect
                      options={ticketTypeOptions}
                      value={selectedTicketTypes}
                      onChange={setSelectedTicketTypes}
                      labelledBy="Select Ticket Types"
                      ArrowRenderer={ArrowRenderer}
                      className="FilterMultiselect"
                      valueRenderer={ValueRendererTicket}
                    />
                  </div>
                

                  <div
                    className="FilterForm_Row"
                 
                  >
                    <label className="form-label">Status</label>
                    {/* <div className="StatusRadioButtons">
                      {statusOptions.map((option) => (
                        <div key={option.value} className="StatusRadio">
                          <input
                            type="radio"
                            id={option.value}
                            name="status"
                            value={option.value}
                            checked={selectedStatus === option.value}
                            onChange={() => handleStatusChange(option.value)}
                          />
                          <label htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </div> */}
                     <MultiSelect
                       options={ticketStatusOptions}
                       value={selectedTicketStatus}
                       onChange={setSelectedTicketStatus}
                       labelledBy="Select Ticket Status"
                       ArrowRenderer={ArrowRenderer}
                       className="DashFilterMultiselect"
                       valueRenderer={ValueRendererTicketStatus}
                    />

                  </div>
                  <div
                    className="FilterForm_Row"
                  >
                    <label className="form-label">Ratings</label>
                    <MultiSelect
                                options={ratingsOptions}
                                value={selectedRatings}
                                onChange={setSelectedRatings}
                                labelledBy="Select Ticket Ratings"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererRatings}
                              />

                  </div>
                </div>
                <div className="FilterForm_Row">
                    <label className="form-label">Created Date</label>
                    <div className="row">
                      <div className="col">
                      
                        <input
                          type={inputType}
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          max={new Date().toISOString().split('T')[0]} // set max to current date
                          className="form-control"
                          placeholder="From"
                          onFocus={() => setInputType('date')}
                          onBlur={() => setInputType('text')}
                        />
                      </div>
                      <div className="col">
                      
                        <input
                          type={inputTypeTo}
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          min={fromDate} // set min to selected fromDate
                          max={new Date().toISOString().split('T')[0]} 
                          className="form-control"
                          placeholder="To"
                          onFocus={() => setInputTypeTo('date')}
                          onBlur={() => setInputTypeTo('text')}
                        />
                      </div>
                    </div>
                  </div>
              </Dropdown.ItemText>
              <Dropdown.ItemText className="FilterContentFooter">
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn ClearAllBtn"
                    onClick={() => handleClearAll()}
                    style={{
                      cursor: "pointer",
                    }}
                    disabled={isApplyFilterDisabled || filterCount === 0}
                  >
                    Clear All
                  </button>
                  <button
                    type="button"
                    className="btn ApplyFilterBtn"
                   

                    onClick={() => {

                      
                      filterDatakeLie();
                                        handleSubmit()
                  
                                      }}
                  
                  
                    disabled={isApplyFilterDisabled || filterCount === 0}
                  >
                    Apply Filter
                  </button>
                </div>
              </Dropdown.ItemText>
            </Dropdown.Menu>
          </Dropdown>
        </div>

      </div> : ""}
    </Fragment>
  );
};

export default Filter;
